module.exports = __webpack_public_path__ + "media/images/ADC_logo_white-85e2816e02ccac171c44db9b6570db04.png";